import env from '@/libs/env'

const {
  isSplitEntryDeclaration,
  entryDeclarationThai,
  entryDeclarationSin,
  entryDeclarationIndo,
} = env
const image = require('@icons/airplane-logo.svg')

export const entryDeclaration = [
  {
    title: 'Entry declaration ThaiLan',
    href: entryDeclarationThai,
    image,
  },
  {
    title: 'Entry declaration Singapore',
    href: entryDeclarationSin,
    image,
  },
  {
    title: 'Entry declaration Indonesia',
    href: entryDeclarationIndo,
    image,
  },
]
  .filter(i => i.href)
  .map(i => {
    if (!isSplitEntryDeclaration) return i
    return ({
      ...i,
      title: i.title.replace('Entry declaration', '').trim(),
      // image: null,
      // customIcon: 'checkSquare',
    })
  })

export default entryDeclaration
